import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "breadcrumb-wrap" }
const _hoisted_4 = { "aria-label": "breadcrumb" }
const _hoisted_5 = { class: "breadcrumb" }
const _hoisted_6 = /*#__PURE__*/_createVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createVNode("a", { href: "javascript:void(0)" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-home" })
  ])
], -1)
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = /*#__PURE__*/_createVNode("li", {
  class: "breadcrumb-item active",
  "aria-current": "page"
}, [
  /*#__PURE__*/_createVNode("a", {
    href: "javascript:void(0)",
    class: "breadcrumb-item active"
  }, "Project Acknowledgement Details")
], -1)
const _hoisted_9 = { class: "card" }
const _hoisted_10 = {
  key: 0,
  class: "card-head pb-3"
}
const _hoisted_11 = { class: "card-title" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fa fa-bookmark mr-1 text-warning" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("h6", { class: "mt-2 text-success" }, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-file-alt mr-1" }),
  /*#__PURE__*/_createTextVNode(" Project Details : ")
], -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "row mt-3" }
const _hoisted_16 = { class: "col-sm-6 mb-3" }
const _hoisted_17 = { class: "shadowed-card h-100" }
const _hoisted_18 = /*#__PURE__*/_createVNode("h6", { class: "text-success" }, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-envelope mr-1" }),
  /*#__PURE__*/_createTextVNode(" Payers Emails: ")
], -1)
const _hoisted_19 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_20 = { class: "flex-shrink-0 avatar-sm" }
const _hoisted_21 = { class: "avatar-wrap rounded-circle" }
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "fas fa-hourglass-half" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_25 = { class: "flex-grow-1 ml-3" }
const _hoisted_26 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "col-sm-6 mb-3" }
const _hoisted_29 = { class: "shadowed-card h-100" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createVNode("i", { class: "fa fa-dollar-sign mr-1" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar mr-1" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Date : ")
const _hoisted_34 = {
  key: 0,
  class: "text-success",
  title: "Start Date"
}
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_36 = {
  key: 1,
  class: "text-danger",
  title: "End Date"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_38 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("h6", { class: "text-success" }, [
  /*#__PURE__*/_createVNode("i", { class: "far fa-file mr-1" }),
  /*#__PURE__*/_createTextVNode(" Edoc Links: ")
], -1)
const _hoisted_40 = { class: "editor-bullet-list p-0 mt-3" }
const _hoisted_41 = { class: "mt-5" }
const _hoisted_42 = /*#__PURE__*/_createVNode("h6", { class: "text-success" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-paperclip mr-1" }),
  /*#__PURE__*/_createTextVNode(" Attachements : ")
], -1)
const _hoisted_43 = {
  key: 0,
  class: "inline-items my-3"
}
const _hoisted_44 = { class: "shadowed-card bg-white" }
const _hoisted_45 = { class: "image-box" }
const _hoisted_46 = { class: "image-wrapp" }
const _hoisted_47 = { class: "file-name bg-light p-2" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "card p-0" }
const _hoisted_51 = { class: "mt-3 mb-5" }
const _hoisted_52 = /*#__PURE__*/_createVNode("div", { class: "px-3" }, [
  /*#__PURE__*/_createVNode("h6", { class: "text-success" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-history mr-1" }),
    /*#__PURE__*/_createTextVNode(" Decline History ")
  ])
], -1)
const _hoisted_53 = { class: "table-responsive mt-3" }
const _hoisted_54 = { class: "table table-borderless mb-0" }
const _hoisted_55 = /*#__PURE__*/_createVNode("thead", { class: "table-light" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Date"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Reason"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Declined By"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Action")
  ])
], -1)
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { class: "pro-detail-wrap" }
const _hoisted_58 = {
  key: 0,
  class: "user-av-list"
}
const _hoisted_59 = { class: "file-actions position-relative" }
const _hoisted_60 = { class: "dropdown" }
const _hoisted_61 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "true"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-v" })
], -1)
const _hoisted_62 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_63 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit mr-2" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Edit")
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { colspan: "4" }
const _hoisted_67 = { class: "mt-3 text-center" }
const _hoisted_68 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit mr-2" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" Edit History Request")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_HistoryTimeLine = _resolveComponent("HistoryTimeLine")
  const _component_ProjectApprovalModalEdit = _resolveComponent("ProjectApprovalModalEdit")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.ui.isLoading.getProjectAcknowledgementApprovalDetail)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode("nav", _hoisted_4, [
        _createVNode("ol", _hoisted_5, [
          _hoisted_6,
          _createVNode("li", _hoisted_7, [
            (
          _ctx.state.data.projectAcknowledgementDetails.project &&
          _ctx.state.data.projectAcknowledgementDetails.project.name
        )
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  href: "javascript:void(0)",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectToProject(_ctx.state.data.projectAcknowledgementDetails.project)))
                }, _toDisplayString(_ctx.state.data.projectAcknowledgementDetails.project.name), 1))
              : _createCommentVNode("", true)
          ]),
          _hoisted_8
        ])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      (
          _ctx.state.data.projectAcknowledgementDetails.project &&
          _ctx.state.data.projectAcknowledgementDetails.project.name
        )
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _createVNode("h1", _hoisted_11, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.state.data.projectAcknowledgementDetails.project.name), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_13,
      (_ctx.state.data.description)
        ? (_openBlock(), _createBlock("p", _hoisted_14, [
            _createVNode("small", null, _toDisplayString(_ctx.state.data.description), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_15, [
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _hoisted_18,
            (
                _ctx.state.data.projectAcknowledgementDetails &&
                _ctx.state.data.projectAcknowledgementDetails.payers
              )
              ? (_openBlock(), _createBlock("div", _hoisted_19, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                  .projectAcknowledgementDetails.payers, (payer, payerIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "mini-stats-wid d-flex mt-2",
                      key: payerIndex
                    }, [
                      _createVNode("div", _hoisted_20, [
                        _createVNode("div", _hoisted_21, [
                          (payer.user && payer.user.image)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                class: "rounded-circle",
                                src: payer.user.image,
                                alt: "",
                                title: payer.user.email
                              }, null, 8, ["src", "title"]))
                            : _createCommentVNode("", true),
                          _createVNode("div", {
                            class: payer.status === 2 ? 'member-status-wrap active accepted' : 'member-status-wrap accepted'
                          }, [
                            _hoisted_22
                          ], 2),
                          _createVNode("div", {
                            class: payer.status === 1 ? 'member-status-wrap active pending' : 'member-status-wrap pending'
                          }, [
                            _hoisted_23
                          ], 2),
                          _createVNode("div", {
                            class: payer.status === 3 ? 'member-status-wrap active declined': 'member-status-wrap declined'
                          }, [
                            _hoisted_24
                          ], 2)
                        ])
                      ]),
                      _createVNode("div", _hoisted_25, [
                        (payer.user && payer.user.full_name)
                          ? (_openBlock(), _createBlock("p", _hoisted_26, [
                              _createVNode("strong", null, _toDisplayString(payer.user.full_name), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (payer.user && payer.user.email)
                          ? (_openBlock(), _createBlock("p", _hoisted_27, _toDisplayString(payer.user.email), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_28, [
          _createVNode("div", _hoisted_29, [
            (
                _ctx.state.data.projectAcknowledgementDetails.payerRequest &&
                _ctx.state.data.projectAcknowledgementDetails.payerRequest.budget
              )
              ? (_openBlock(), _createBlock("p", _hoisted_30, [
                  _hoisted_31,
                  _createTextVNode(" Estimated Budget : $" + _toDisplayString(_ctx.state.data.projectAcknowledgementDetails.payerRequest.budget), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("p", null, [
              _hoisted_32,
              _hoisted_33,
              (
                  _ctx.state.data.projectAcknowledgementDetails.payerRequest &&
                  _ctx.state.data.projectAcknowledgementDetails.payerRequest
                    .convStartDate
                )
                ? (_openBlock(), _createBlock("small", _hoisted_34, _toDisplayString(_ctx.state.data.projectAcknowledgementDetails.payerRequest
                    .convStartDate), 1))
                : _createCommentVNode("", true),
              _hoisted_35,
              (
                  _ctx.state.data.projectAcknowledgementDetails.payerRequest &&
                  _ctx.state.data.projectAcknowledgementDetails.payerRequest.convEndDate
                )
                ? (_openBlock(), _createBlock("small", _hoisted_36, _toDisplayString(_ctx.state.data.projectAcknowledgementDetails.payerRequest.convEndDate), 1))
                : _createCommentVNode("", true)
            ]),
            _hoisted_37,
            (
                _ctx.state.data.projectAcknowledgementDetails.payerRequest.edoc_id
              )
              ? (_openBlock(), _createBlock("div", _hoisted_38, [
                  _hoisted_39,
                  _createVNode("div", _hoisted_40, [
                    _createVNode("ul", null, [
                      _createVNode("li", null, [
                        _createVNode("small", null, [
                          _createVNode("a", {
                            href: "javascript:void(0)",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToDoc && _ctx.redirectToDoc(...args)))
                          }, _toDisplayString(_ctx.state.data.projectAcknowledgementDetails.payerRequest
                          .edoc_id), 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_41, [
        _hoisted_42,
        (
            _ctx.state.data.projectAcknowledgementDetails &&
            _ctx.state.data.projectAcknowledgementDetails.attachments
          )
          ? (_openBlock(), _createBlock("div", _hoisted_43, [
              _createVNode("ul", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                .projectAcknowledgementDetails.attachments, (attachment, attachmentIndex) => {
                  return (_openBlock(), _createBlock("li", { key: attachmentIndex }, [
                    _createVNode("div", _hoisted_44, [
                      _createVNode("div", _hoisted_45, [
                        _createVNode("div", _hoisted_46, [
                          _createVNode("img", {
                            src: attachment.activeLink,
                            alt: "",
                            height: "150",
                            width: "180"
                          }, null, 8, ["src"]),
                          _createVNode("div", _hoisted_47, [
                            (attachment.file_name)
                              ? (_openBlock(), _createBlock("h5", _hoisted_48, _toDisplayString(attachment.file_name), 1))
                              : _createCommentVNode("", true),
                            (attachment.convertedFileSize)
                              ? (_openBlock(), _createBlock("p", _hoisted_49, " (" + _toDisplayString(attachment.convertedFileSize) + ") ", 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_50, [
      _createVNode("div", _hoisted_51, [
        _hoisted_52,
        _createVNode("div", _hoisted_53, [
          _createVNode("table", _hoisted_54, [
            _hoisted_55,
            (
                _ctx.state.data.projectAcknowledgementDetails.payerRequest
                  .declineReasons &&
                _ctx.state.data.projectAcknowledgementDetails.payerRequest
                  .declineReasons.length
              )
              ? (_openBlock(), _createBlock("tbody", _hoisted_56, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                  .projectAcknowledgementDetails.payerRequest.declineReasons, (decline, declineIndex) => {
                    return (_openBlock(), _createBlock("tr", { key: declineIndex }, [
                      _createVNode("td", null, [
                        _createVNode("small", null, _toDisplayString(decline.created_at), 1)
                      ]),
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_57, [
                          _createVNode("small", null, _toDisplayString(decline.description), 1)
                        ])
                      ]),
                      _createVNode("td", null, [
                        (decline.user && decline.user.image)
                          ? (_openBlock(), _createBlock("div", _hoisted_58, [
                              _createVNode("img", {
                                src: decline.user.image,
                                alt: "task-user",
                                class: "avatar-sm img-thumbnail rounded-circle mb-1 mr-1"
                              }, null, 8, ["src"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_59, [
                          _createVNode("div", _hoisted_60, [
                            _hoisted_61,
                            _createVNode("div", _hoisted_62, [
                              _createVNode("a", {
                                class: "dropdown-item",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (
                            _ctx.showEditProjectAcknowledgementByDeclineSelected(
                              decline
                            )
                          )
                              }, [
                                _hoisted_63,
                                _hoisted_64
                              ], 8, ["onClick"])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("tbody", _hoisted_65, [
                  _createVNode("tr", null, [
                    _createVNode("td", _hoisted_66, [
                      _createVNode(_component_EmptyData, {
                        title: _ctx.state.data.declineTitle,
                        heading: _ctx.state.data.declineHeading
                      }, null, 8, ["title", "heading"])
                    ])
                  ])
                ]))
          ])
        ])
      ])
    ]),
    (_ctx.state.data.projectAcknowledgementDetails.payerRequest.history && _ctx.state.data.projectAcknowledgementDetails.payerRequest.history.length)
      ? (_openBlock(), _createBlock(_component_HistoryTimeLine, {
          key: 1,
          history: _ctx.state.data.projectAcknowledgementDetails.payerRequest.history
        }, null, 8, ["history"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_67, [
      _createVNode("a", {
        class: "btn default-btn",
        href: "javascript:void(0)",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showEditProjectAcknowledgement && _ctx.showEditProjectAcknowledgement(...args)))
      }, [
        _hoisted_68,
        _hoisted_69
      ])
    ]),
    (_ctx.state.ui.modal.showEditProjectAcknowledgementModal)
      ? (_openBlock(), _createBlock(_component_ProjectApprovalModalEdit, {
          key: 2,
          showModal: _ctx.state.ui.modal.showEditProjectAcknowledgementModal,
          selectedProject: _ctx.state.data.projectAcknowledgementDetails,
          selectedDecline: _ctx.state.data.selectedDeclineHistory,
          onClose: _ctx.hideEditProjectAcknowledgement,
          onAcknowledgedData: _ctx.setAcknowledgedData
        }, null, 8, ["showModal", "selectedProject", "selectedDecline", "onClose", "onAcknowledgedData"]))
      : _createCommentVNode("", true)
  ]))
}